import React from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { getIsHotelOnly } from 'src/store/view/selectors';
import Searcher from '../Searcher';
import SearcherResults from '../SearcherResults';
import SearcherOperators from '../SearcherOperators';

const StyledContainer = styled.div`
  ${({ isMobile }) =>
    isMobile &&
    css`
      padding-right: 5px;
      padding-left: 5px;
    `}
`;

const SearcherContainer = ({ isHotelOnly, ...props }) => (
  <StyledContainer {...props}>
    <Searcher />
    {!isHotelOnly && <SearcherOperators />}
    <SearcherResults />
  </StyledContainer>
);

const mapStateToProps = (state) => ({
  isHotelOnly: getIsHotelOnly(state),
});

export default connect(mapStateToProps)(SearcherContainer);
